module.exports = __webpack_public_path__ + "img/workers.19ae5e76.png";